export const isValidCompanyId = (companyId: string) => {
    const regexpCompanyId = /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/g;

    return companyId.length === 36 && regexpCompanyId.test(companyId);
};
